export default {
  'get-list': {
    method: 'post',
    url: '/client/vehicle/category/list'
  },
  getAll: {
    method: 'post',
    url: '/client/vehicle/category/get-all'
  },
  getAllList: {
    method: 'get',
    url: '/client/vehicle/category/list'
  },
  add: {
    method: 'post',
    url: '/client/vehicle/category'
  },
  delete: {
    url: '/client/vehicle/category',
    method: 'delete'
  },
  getById: {
    url: '/client/vehicle/category/ID',
    method: 'get'
  },
  edit: {
    url: '/client/vehicle/category/ID',
    method: 'put'
  },
  find: {
    method: 'get',
    url: '/client/vehicle/category/find?key=KEY&vehicleLoad=vehicleLoadData&QUERY'
  },
  'find-by-vehicle-tonnage': {
    method: 'get',
    url: '/client/vehicle/category/find-by-vehicle-tonnage?key=KEY'
  },
  lastCategory: {
    method: 'get',
    url: '/client/vehicle/category/last-category'
  }
}
